module.exports = __webpack_public_path__ + "img/integration2.3558f181.png";